var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16.017"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.625 3.228H10.8a2.6 2.6 0 005.053 0h3.521a.625.625 0 000-1.25h-3.52a2.6 2.6 0 00-5.053 0H.625a.625.625 0 000 1.25zm12.7-1.978a1.353 1.353 0 11-1.353 1.353 1.354 1.354 0 011.356-1.353zM.625 8.633h3.521a2.6 2.6 0 005.053 0h10.176a.625.625 0 000-1.25H9.2a2.6 2.6 0 00-5.053 0H.625a.625.625 0 000 1.25zm6.047-1.977A1.353 1.353 0 115.32 8.008a1.354 1.354 0 011.352-1.352zm12.7 6.133h-3.518a2.6 2.6 0 00-5.053 0H.625a.625.625 0 000 1.25H10.8a2.6 2.6 0 005.053 0h3.521a.625.625 0 100-1.25zm-6.047 1.978a1.353 1.353 0 111.355-1.351 1.354 1.354 0 01-1.352 1.351z",
    fill: "currentColor"
  })));
}

export default SvgFilterinline;